export default {
  search: ['请输入您要搜索的访问控制名称', 'Please Enter the Acl Name'],
  name: ['访问控制名称', 'Acl Name'],
  key: ['访问控制键', 'Acl Key'],
  write: ['可写列表', 'Write Lists'],
  read: ['可读列表', 'Read Lists']
};
